export default [
  {
    text: 'Normal',
    value: 1,
    type: 'STANDARD',
    typeReturnAPI: 'NORMAL',
  },
  {
    text: 'Expresso',
    value: 2,
    type: 'EXPRESS',
    typeReturnAPI: 'NORMAL',
  },
  {
    text: 'Prioritário',
    value: 3,
    type: 'PRIORITY',
    typeReturnAPI: 'NORMAL',
  },
  {
    text: 'Retirada',
    value: 4,
    type: 'PICKUP',
    typeReturnAPI: 'NORMAL',
  },
  {
    text: 'Retirada em Locker',
    value: 5,
    type: 'PICKUP_LOCKER',
    typeReturnAPI: 'NORMAL',
  },
  {
    text: 'Retirada em pontos',
    value: 6,
    type: 'PICKUP_POINT',
    typeReturnAPI: 'NORMAL',
  },
  {
    text: 'Entrega no mesmo dia',
    value: 7,
    type: 'SAME_DAY',
    typeReturnAPI: 'NORMAL',
  },
  {
    text: 'Agendado',
    value: 8,
    type: 'SCHEDULED',
    typeReturnAPI: 'NORMAL',
  },
  {
    text: 'Reversa',
    value: 9,
    type: 'RETURN',
    typeReturnAPI: 'RETURN',
  },
];



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quoting-return/enum/EnumMethodTypes.js